<template>
<div class="jgkb screen-container flex-column">
  <!-- <div class="flex-column" :style="{'width': '1920px', 'flex': `0 0 ${$root.docHeight*1920/$root.docWidth}px`,'transform': `scale(${$root.docWidth/1920},${$root.docHeight/($root.docHeight*1920/$root.docWidth)})`,'transform-origin': '0 0'}"> -->
    <Header :title="`价格看板(${$root.docWidth} x ${$root.docHeight})`"></Header>
    <div class="flex-column flex-auto padding-top-20 padding-lr-20">
      <el-row :gutter="20" type="flex" class="flex-auto">
        <el-col :span="6">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">汽油(92#国V)日度市场价走势</div>
                </div>
              </div>
              <Chart :option="chartOption3" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">柴油(0#国V)日度市场价走势</div>
                </div>
              </div>
              <Chart :option="chartOption3" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="myColumn flex-column" style="flex:none">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">价格跟踪</div>
                </div>
              </div>
              <div ref="div1" @mouseover="tableScroll.tableMouseOver=1" @mouseout="tableScroll.tableMouseOver=0" style="flex:auto;overflow:hidden;margin-top:10px;border-radius: 10px;">
                <el-table
                  :data="table"
                  :show-header="true"
                  style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="产品名称"
                    show-overflow-tooltip
                  >
                  <template slot-scope="props">
                    <div class="font-size-16 bold padding-tb-10" :style="{'margin':`${$root.docHeight*0.005}px 0`}">{{props.row.name}}</div>
                  </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="区域">
                    <template><span class="font-size-16 bold">山东</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="规格型号">
                    <template><span class="font-size-16 bold">--</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="最低价">
                    <template>
                        <div class="font-size-16 bold padding-tb-10" style="position: relative;">
                          <span>8648</span> 
                          <span class="new-icon" style="position:absolute; top:0; right: -5px;"></span>
                        </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="最高价">
                    <template><span class="font-size-16 bold">8856</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="平均价">
                    <template><span class="font-size-16 bold">8752</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="日涨跌幅">
                    <template><span class="font-size-16 bold color-red">5%</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="周均价">
                    <template><span class="font-size-16 bold">8658</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="周涨跌幅">
                    <template><span class="font-size-16 bold color-green">-5%</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="月均价">
                    <template><span class="font-size-16 bold">8965</span></template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="value"
                    label="月涨跌幅">
                    <template><span class="font-size-16 bold color-red">5%</span></template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">原油日度期货结算价走势</div>
                </div>
              </div>
              <Chart :option="chartOption3" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">动力煤(Q5000)日度市场价走势</div>
                </div>
              </div>
              <Chart :option="chartOption3" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">苯乙烯日度市场价走势</div>
                </div>
              </div>
              <Chart :option="chartOption3" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  <!-- </div> -->
</div>
</template>

<script>
import Header from "@/components/header/Header.vue";
import Chart from "@/components/Chart";
import '@/common/china.js'//注册echarts中国地图
export default {
  name: 'Home',
  components:{
    Chart,
    Header
  },
  data(){
    return {
      dialogVisible:true,
      isFixed:true,
      chartOption:null,
      chartOption1:null,
      chartOption2:null,
      chartOption3:null,
      chartOption4:null,
      chartOption5:null,
      table:[
        {name:'汽油',value:'9.04万吨'},
        {name:'柴油',value:'8.33万吨'},
        {name:'	苯乙烯 ',value:'29.55万吨'},
        {name:'动力煤',value:'509.90万吨'},
        {name:'纯苯',value:'11.76万吨'},
      ],
      
      tableScroll:{
         tableMouseOver:0,
         step:48,
      }
       

    }
  },
  created(){

  },
  methods:{
    scroll(obj){
     
       obj.scrollHeight>obj.clientHeight&&(obj.innerHTML+=obj.innerHTML);
       let fun=()=>{
        if(obj.scrollTop%this.tableScroll.step||!this.tableScroll.tableMouseOver){
            obj.scrollTop++
            obj.scrollTop%=obj.scrollHeight>>1
          }
        setTimeout(fun,obj.scrollTop%this.tableScroll.step?10:3000)
       }
       fun()
    }
  },
  mounted(){
   this.$nextTick(()=>{
    // this.scroll(this.$refs['div1'])
  })

    setTimeout(()=>{
      //k线line组合图表
      let opt=JSON.parse(JSON.stringify(this.$defaultChartOption)) 
      opt.yAxis.name='元/吨'
      opt.legend.data=[
        {
            name:'平均值',
            unit:"元/吨",
            itemStyle:{
                opacity:0
            }
        },
         {
            name:'价格走势',
            unit:"千吨",
        },
      ]
      opt.xAxis.data=['2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2','2020-1-2']
      opt.series= [
        {
          name:'平均值',
          type: 'line',
           data: [27, 37, 35, 27, 27, 37, 35, 27, 27, 37, 35,27],
        },
        {
          name:'价格走势',
          type: 'k',
          barMaxWidth:'20',
          
          itemStyle: {
            color: '#fd6864' ,
            color0: '#11bf99' ,
            borderColor: '#fd6864' ,
            borderColor0: '#11bf99' ,
          },
          data: [
              [20, 34, 10,38],
              [40, 35, 30, 50],
              [31, 38, 33, 44],
              [38, 15, 5, 42],
              [20, 34, 10,38],
              [40, 35, 30, 50],
              [31, 38, 33, 44],
              [38, 15, 5, 42],
              [20, 34, 10,38],
              [40, 35, 30, 50],
              [31, 38, 33, 44],
              [38, 15, 5, 42]
          ]
        }
      ]
      opt.tooltip.formatter = (params)=>{
        var str=`<div>${params[0].axisValue}</div>`
        params.forEach((val)=>{
          if(val.seriesType=='candlestick'){
            str+=`<div>${val.marker}${val.seriesName}</div>
                  <div>期初值：${val.data[1]}${opt.legend.data[val.seriesIndex].unit}</div>
                  <div>期末值：${val.data[2]}${opt.legend.data[val.seriesIndex].unit}</div>
                  <div>最低值：${val.data[3]}${opt.legend.data[val.seriesIndex].unit}</div>
                  <div>最高值：${val.data[4]}${opt.legend.data[val.seriesIndex].unit}</div>`
          }else{
            str+=`<div>${val.marker}${val.seriesName}：${val.data}${opt.legend.data[val.seriesIndex].unit}</div>`
          }
        })
        return str
      }
      this.chartOption=opt 

      //饼图
      let opt1 =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
      opt1.tooltip= {
          trigger: 'item'
        },
      opt1.series=[
         {
          type: 'pie',
          radius: '60%',
          data: [
            { value: 1048, name: '山东' },
            { value: 735, name: '河南' },
            { value: 580, name: '辽宁' },
            { value: 484, name: '河北' },
            { value: 300, name: '江苏' }
          ],
          label:{
            formatter:'{b}\n{c}（{d}%）',
            textBorderWidth:0,
            fontSize:14,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
      this.chartOption1=opt1

      //横向柱状图表
      let opt2 =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
      opt2.legend.data=["AAA1",'AAA2','AAA3']
      
      opt2.xAxis.type='value',
      opt2.yAxis.type='category',
      opt2.yAxis.data=[2012,2013,2014,2015]
      opt2.series=[
        {
            name:'AAA1',
            data: [800,900,1250,658],
            type: 'bar',
            barMaxWidth:'20',
            itemStyle:{
              borderRadius:[0,5,5,0]
            }
        },
        {
            name:'AAA2',
            data: [800,900,1250,658],
            type: 'bar',
            barMaxWidth:'20',
            itemStyle:{
              borderRadius:[0,5,5,0]
            }
        },
        {
            name:'AAA3',
            data: [800,900,1250,658],
            type: 'bar',
            barMaxWidth:'20',
            itemStyle:{
              borderRadius:[0,5,5,0]
            }
        },
      ]
      this.chartOption2=opt2
    },0)

    setTimeout(()=>{
      let opt3 =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
      opt3.legend.data=[
        {
          name:'AAA',
          //如果图表组件显示自定义图例，custom字段必传，invisible：该自定义图例是否不显示，默认false，显示,color:自定义图例颜色，不定义取默认取图例颜色列表中的颜色
          custom:{
            color:"#ff0000",
            unit:"千吨",
            invisible:true
          },
          itemStyle:{
              opacity:0
          }
        },{
          name:'BBB',
          custom:{
            unit:"元/吨",
            formatter:val=>{
              return val+"aaa"
            }
          },
          itemStyle:{
              opacity:0
          }
        }
      ]
      opt3.yAxis.name = '元/吨'
      opt3.xAxis.boundaryGap = false
      opt3.xAxis.data=[2012,2013,2014,2015,2012,2013,2014,2015,2012,2013,2014,2015,2012,2013,2014,2015]
      opt3.series=[
        {
            name:'AAA',
            data:  [9125,9256,9245,9541,9548,9690,9874,9789,9654,9671,9653,9585,9475,9521,9635,9654],
            type: 'line',
        },
        {
            name:'BBB',
            data:  [9125,9654,9541,9475,9690,9671,9789,9874,9653,9585,9521,9635,9654,9256,9245,9548],
            type: 'line',
        },
      ]
      this.chartOption3=opt3
    },1000)

    //地图图标
    this.chartOption4 = {
      backgroundColor: 'transparent',
      tooltip:{
        formatter: function(){
          return ''
        },
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      },
      visualMap:{
        type:'continuous',
        left:'right',
        mix:1,
        max:50,
        inRange:{
           color: ['#cefbf2', '#0d9479'],
        },
        text:[50,1],
        
      },
      series:[{
        type:'map',
        map:'china',    
        top:0,
        bottom:0,
        selectedMode: false,
        itemStyle:{
          areaColor:'rgba(160,160,160,0.3)',
          borderColor:'rgba(160,160,160,0.4)',
        },
        emphasis:{
          itemStyle:{
            areaColor:'rgba(160,160,160,0.3)',
            borderColor:'rgba(160,160,160,0.4)',
          },
          label:{
            show:true,
          }
        },
        data:[{
            name: '山东',
            value: 50,
            tooltip:{
              formatter: '{b}: {c}'
            },
            emphasis:{
              itemStyle:{
                  areaColor:'#ffc069'
              }
            }
        }, {
            name: '河北',
            value: 20,
            tooltip:{
              formatter: '{b}: {c}'
            },
            emphasis:{
              itemStyle:{
                  areaColor:'#ffc069'
              }
            }
        },
        {
            name: '江苏',
            value: 40,
            tooltip:{
              formatter: '{b}: {c}'
            },
            emphasis:{
              itemStyle:{
                  areaColor:'#ffc069'
              }
            }
        },
        {
            name: '山西',
            value:30,
            tooltip:{
              formatter: '{b}: {c}'
            },
            emphasis:{
              itemStyle:{
                  areaColor:'#ffc069'
              }
            }
        },{
            name: '广东',
            value:5,
            tooltip:{
              formatter: '{b}: {c}'
            },
            emphasis:{
              itemStyle:{
                  areaColor:'#ffc069'
              }
            }
        },]
      }]
    };
    //柱状图
    setTimeout(()=>{
      let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
      opt.legend.data=[
        "AAA1",'AAA2','AAA3'
      ]
      opt.yAxis.name = '元/吨'
      opt.xAxis.boundaryGap = true
      opt.xAxis.data=[2012,2013,2014,2015,2012,2013,2014,2015,2012,2013,2014,2015,2012,2013,2014,2015]
      opt.series=[
        {
            name:'AAA1',
            data:  [9225,9366,9105,9521,9348,9835,8874,9623,9354,9554,9753,9285,9375,9621,9735,9654],
            barMaxWidth:20,
            type: 'line',
            color:"orange"
        },
        {
            name:'AAA2',
            data:  [9125,9256,9245,9541,9548,9235,9874,9523,9654,9254,9653,9585,9475,9521,9635,9654],
            barMaxWidth:20,
            type: 'bar',
            itemStyle:{
              borderRadius:[5,5,0,0]
            }
        },
        {
            name:'AAA3',
            data:  [9125,9256,9245,9541,9548,9235,9874,9523,9654,9254,9653,9585,9475,9521,9635,9654],
            barMaxWidth:20,
            type: 'bar',
            itemStyle:{
              borderRadius:[5,5,0,0]
            }
        },
      ]
      this.chartOption5=opt
    },1000)
  },
  watch: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import './assets/css/common.scss';
</style>
<style scoped lang="scss">
  .num_big{
    font-weight: bold;
    font-size: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .num_big>div{
    height: 50px;
    flex:1;
    overflow: hidden;
    position: relative;
    margin-right: 2px;
    border-radius: 3px;
    @include themeify{
        background: themed('columnBackground');
        border: solid 1px themed('lineColor');
        box-shadow: 0 0 5px themed('shineShadow') inset
    };
  }
  .num_big>div>div{
    position: absolute;
    width: 100%;
    text-align: center;
    top: 0;
    left: 0;
    transition: all 0.5s ease 0s; 
  }
  .num_big>div>div>span{
    display: block;
    height: 50px;
    line-height: 50px;
  }
  .new-icon{
    width: 20px;
    height: 12px;
    background: url("~@/assets/images/new.png");
  }
</style>
